import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Icon,
  Image,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from 'semantic-ui-react';

function ImagePreviewModal({ title, url, open, onClose }) {
  const [hasError, setHasError] = useState(false);

  const handleClose = () => {
    setHasError(false);
    onClose();
  };

  const httpsUrl = url && url.replace('http://', 'https://');

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalHeader>{title}</ModalHeader>
      <ModalContent>
        {hasError ? (
          <div style={{ textAlign: 'center', padding: '2em 0' }}>
            <Icon name="file outline" size="huge" color="grey" />
            <p>Preview not available for this file</p>
            <Button
              as="a"
              href={httpsUrl}
              target="_blank"
              rel="noopener noreferrer"
              primary
              icon="download"
              content="Download file"
            />
          </div>
        ) : (
          <Image
            src={httpsUrl}
            size="large"
            centered
            onError={() => setHasError(true)}
          />
        )}
      </ModalContent>
      <ModalActions>
        <Button basic onClick={handleClose}>
          Close
        </Button>
      </ModalActions>
    </Modal>
  );
}

ImagePreviewModal.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

ImagePreviewModal.defaultProps = {
  title: '',
  url: null,
};

export default ImagePreviewModal;
